/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const masterData = createAsyncThunk(
    "masterData/masterData",
    async (type, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/admin/v1/master/${type}`);
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const addMasterData = createAsyncThunk(
    "masterData/addMasterData",
    async ({ type, name }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`/api/admin/v1/master`, {
                type,
                name
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateMasterDataStatus = createAsyncThunk(
    "masterData/updateMasterDataStatus ",
    async ({ id, type,action }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`/api/admin/v1/master/${id}`, {
                type,
                action
            });

            return response.data; // updated object
        } catch (error) {
            return rejectWithValue(error || "Something went wrong");
        }
    }
);




export const masterDataSlice = createSlice({
    name: "masterData",
    initialState,

    extraReducers: (builder) => {
        builder.addCase(masterData.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(masterData.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(masterData.rejected, (state, action) => {
            state.loading = false;
            state.data = null;
            state.error = action.payload;
        });

        builder.addCase(addMasterData.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(addMasterData.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(addMasterData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(updateMasterDataStatus.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateMasterDataStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(updateMasterDataStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },

    reducers: {
    },
});

export const { } = masterDataSlice.actions;

export default masterDataSlice.reducer;
